import { jsx as e } from "@emotion/core";
import { createContext as r, useState as t, useEffect as n } from "react";
var o = {
    currentBp: ""
  },
  i = r(o),
  u = function (r) {
    var u = r.children,
      c = t(o),
      a = c[0],
      v = c[1];
    return n(function () {
      var e,
        r,
        t,
        n = (e = function () {
          var e = window.getComputedStyle(document.body, "::before").getPropertyValue("content").replace(/"/g, "");
          a.currentBp !== e && v({
            currentBp: e
          });
        }, r = 100, function () {
          for (var n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
          var i = function () {
            return e.apply(void 0, n);
          };
          clearTimeout(t), t = setTimeout(i, r);
        });
      return n(), window.addEventListener("resize", n), function () {
        window.removeEventListener("resize", n);
      };
    }, []), e(i.Provider, {
      value: a
    }, u);
  };
export { i as BreakpointContext, u as BreakpointProvider };